// extracted by mini-css-extract-plugin
module.exports = {"brandIcon":"_a2cccc4","desktopLogo":"_7bdb1af","tabletLogo":"_5dedeac","pokerstarsIcon":"_8ac30d0"};